import request from '@/http/request'

const base = `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/nddc/store/configuration`

export const findNddcStoreConfigurationPage = params => {
  return request.post(`${base}/findNddcStoreConfigurationPage`, params)
}

export const saveNddcStoreConfiguration = params => {
  if (params.id != null && params.id !== '') {
    return request.post(`${base}/update`, params, { hiddenError: true })
  }
  return request.post(`${base}/add`, params, { hiddenError: true })
}

export const disableOrActiveNddcStoreConfiguration = params => {
  return request.post(`${base}/disableOrActive`, params)
}

export const exportNddcStoreConfiguration = params => {
  return request.post(`${base}/exportNddcStoreConfiguration`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const findNddcStoreConfigurationDropDown = () => {
  return request.get(`${base}/findDropDown`)
}
